import { RequireConnectionClickable } from '@ui/features/Wallet/components/RequireConnectionClickable';
import { Order } from '@ui/hooks/trade/useTradeOrders/types';
import { Button } from '@ui/lib/park/ui/button';
import { useTranslation } from 'next-i18next';

import { useCancelLimitOrder } from './hooks/useCancelLimitOrder';

export const CancelButton = ({ order }: { order: Order }) => {
  const { t } = useTranslation();
  const {
    writeContract: cancelLimitOrder,
    isPending: isCancelLimitOrderPending,
  } = useCancelLimitOrder({
    order,
  });

  return (
    <RequireConnectionClickable>
      <Button
        w={{
          base: 'full',
          // compact fixed width like the positions Close button — 80% of a
          // stretchy grid track read as a slab
          desktop: '60px',
        }}
        // V2 compact row button on desktop (24–28px), full-size in mobile cards
        h={{ desktop: '26px' }}
        px={{ desktop: '10px' }}
        py={{ desktop: '0' }}
        variant="secondary"
        onClick={cancelLimitOrder}
        loading={isCancelLimitOrderPending}
      >
        {t('common.Cancel')}
      </Button>
    </RequireConnectionClickable>
  );
};
